var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollDownArrowsOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "364.39mm",
    height: "283.76mm",
    viewBox: "0 0 364.39 283.76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.99 -48.939)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-113.39 49.057 182.18 92.226 181.01-92.226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-113.39 143.64 182.18 92.226 181.01-92.226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-113.39 239.29 182.18 92.226 181.01-92.226"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDownArrowsOptimized);
export default __webpack_public_path__ + "static/media/scroll-down-arrows-optimized.ab5e1fe2.svg";
export { ForwardRef as ReactComponent };